import React, { useState } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { DateTime } from "luxon";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

function MonthFilter({
  goForwardYear,
  goBackYear,
  goBackMonth,
  dateStart,
  lastMonth,
  dateEnd,
  goForwardMonth,
}) {
  const [openBox, setOpenBox] = useState(false);
  return (
    <div className="month_filter">
      <div className={`month_filter-openBox ${openBox}`}>
        <div
          className="month_filter-openBox_close"
          onClick={() => setOpenBox(false)}
        >
          <KeyboardArrowDownIcon />
        </div>
        <div className="dayBox">
          <div className="iconBox">
            <ArrowBackIosIcon onClick={() => goBackMonth()} />
          </div>
          <p className="main">
            {DateTime.fromISO(dateStart).toFormat("MMMM")}  
          </p>
          <div className="iconBox">
            <ArrowForwardIosIcon
              onClick={() => (dateEnd === lastMonth ? null : goForwardMonth())}
            />
          </div>
        </div>
        <div className="dayBox">
          <div className="iconBox">
            <ArrowBackIosIcon onClick={() => goBackYear()} />
          </div>
          <p className="main">{DateTime.fromISO(dateStart).toFormat("y")}</p>
          <div className="iconBox">
            <ArrowForwardIosIcon
              onClick={() => (dateEnd === lastMonth ? null : goForwardYear())}
            />
          </div>
        </div>
      </div>
      <div
        className="month_filter-dateChanger"
        onClick={() => setOpenBox(true)}
      >
        <p className="dayName main">{DateTime.fromISO(dateStart).toFormat("MMMM")}</p>
        <p className="dayName main">{DateTime.fromISO(dateEnd).toFormat("y")}</p>
        <KeyboardArrowDownIcon className="open" />
      </div>
      <div className="month_filter-switch"></div>
    </div>
  );
}

export default MonthFilter;
